/**
 * The external dependencies.
 */
import React from "react";
import { connect } from "react-redux";

/**
 * Returns the account id
 *
 * @param {Object} / The router match
 * @return {JSX}
 */
const StudentAttemptBreadCrumb = ({ name }) => <span>{name}</span>;

export default connect((state) => {
  const name = state.facultyDashboard.studentAttempt.attemptNumber
    ? "Attempt " + state.facultyDashboard.studentAttempt?.attemptNumber
    : "";
  return { name };
})(StudentAttemptBreadCrumb);
